import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { espacamento } from '../../styles/constants/sizes';

export const BotaoForm = styled.button`
  border-radius: 4px;
  padding: ${espacamento.pequeno}px ${espacamento.medio}px;
  align-items: center;
  cursor: pointer;
  border: none;
  outline: none;
  color: #fff;
  background-color: #54a0ff;
  font-weight: 600;
  font-size: .92em;

  :hover {
    background-color: #3467cc;
  }
`;

export const BotaoFormTotem = styled.button`
  border-radius: 4px;
  padding: 22px 62px;
  align-items: center;
  cursor: pointer;
  border: none;
  outline: none;
  color: #fff;
  background-color: #54a0ff;
  font-size: 1.50em;
  margin-top: 40px;
  margin-bottom: 20px;

  :hover {
    background-color: #3467cc;
  }
`;

export const BotaoTopo = styled.button`
border-radius: 4px;
padding: ${espacamento.pequeno}px ${espacamento.medio}px;
align-items: center;
cursor: pointer;
border: none;
outline: none;
color: #fff;
background-color: gray;
font-size: .92em;

:hover {
  background-color: #adadad;
}
`;

export const BotaoAdicionar = styled.button`
  position: fixed;
  right: 50px;
  bottom: 50px;
  z-index: 2;
  border-radius: 100%;
  border: 0;
  outline: none;
  padding: 12px 14px;
  background-color: rgb(42, 122, 226);
  color: #fff;
  cursor: pointer;

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px 0 rgba(0,0,0,0.5);
  }
`;

export const BotaoAjuda = styled.button`
  position: fixed;
  right: 50px;
  bottom: 50px;
  z-index: 2;
  border-radius: 100%;
  border: 0;
  outline: none;
  padding: 12px 14px;
  background-color: #ccc;
  color: #fff;
  cursor: pointer;

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px 0 rgba(0,0,0,0.5);
  }
`;

export const BotaoUpTotemAcompanhamento = styled.button`
  position: fixed;
  right: 50px;
  top: 80px;
  z-index: 2;
  border-radius: 10px;
  border: 0;
  outline: none;
  padding: 21px 21px;
  background-color: white;
  color: #fff;
  cursor: pointer;background-color: white;

  svg {
    fill: #646464 !important;
    :active {
      fill: #858585;
    }
  }
`;

export const BotaoUpTotem = styled.button`
  position: fixed;
  right: 35px;
  top: 25px;
  z-index: 2;
  border-radius: 10px;
  border: 0;
  outline: none;
  padding: 5px 5px;
  background-color: white;
  color: #fff;
  cursor: pointer;

  svg {
    fill: #646464 !important;
    :active {
      fill: #858585;
    }
  }
`;

export const BotaoSairTotem = styled.button`
  position: absolute;
  left: 25px;
  bottom: 25px;
  z-index: 2;
  border-radius: 10px;
  border: 0;
  outline: none;
  padding: 3px 5px;
  padding-bottom: -2px;
  background-color: white;
  color: #fff;
  cursor: pointer;

  svg {
    fill: #646464 !important;
    :active {
      fill: #858585;
    }
  }
`;

export const BotaoVoltarTotemNude = styled.button`
  position: fixed;
  left: 25px;
  top: 25px;
  z-index: 2;
  border-radius: 10px;
  border: 0;
  outline: none;
  padding: 3px 3px;
  color: #fff;
  cursor: pointer;
  background-color: white;

  svg {
    fill: #646464 !important;
    :active {
      fill: #858585;
    }
  }
`;

export const BotaoVoltarTotem = styled.button`
  position: fixed;
  left: 25px;
  top: 25px;
  z-index: 2;
  border-radius: 10px;
  border: 0;
  outline: none;
  padding: 3px 3px;
  background-color: white;
  color: #fff;
  cursor: pointer;
  transform: rotate(-90deg);

  svg {
    fill: #646464 !important;
    :active {
      fill: #858585;
    }
  }
`;

export const BotaoDownTotem = styled.button`
  position: fixed;
  right: 35px;
  bottom: 25px;
  z-index: 2;
  border-radius: 10px;
  border: 0;
  outline: none;
  padding: 5px 5px;
  background-color: white;
  cursor: pointer;

  :active{
    border-radius: 10px;
  }
  

  svg {
    fill: #646464 !important;
    :active {
      border-radius: 10px;
      fill: #858585;
    }
  }
`;

export const BotaoAjudaTotem = styled.button`
  position: fixed;
  right: 25px;
  bottom: 25px;
  z-index: 2;
  border-radius: 100%;
  border: 0;
  outline: none;
  padding: 12px 14px;
  background-color: #ccc;
  color: #fff;
  cursor: pointer;

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px 0 rgba(0,0,0,0.5);
  }
`;

export const BotaoUp = styled.button`
  position: fixed;
  right: 50px;
  bottom: 550px;
  z-index: 2;
  border-radius: 100%;
  border: 0;
  outline: none;
  padding: 12px 14px;
  background-color: #ccc;
  color: #fff;
  cursor: pointer;

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px 0 rgba(0,0,0,0.5);
  }
`;

export const BotaoWhats = styled.button`
  position: fixed;
  right: 45px;
  bottom: 190px;
  z-index: 2;
  border-radius: 100%;
  border: 0;
  outline: none;
  padding: 10px 12px;
  cursor: pointer;

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px 0 rgba(0,0,0,0.5);
  }
`;

export const BotaoWhats2 = styled.button`
  position: fixed;
  right: 50px;
  bottom: 120px;
  z-index: 2;
  border-radius: 100%;
  border: 0;
  outline: none;
  padding: 10px 12px;
  cursor: pointer;

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px 0 rgba(0,0,0,0.5);
  }
`;

export const BotaoInformacaoAcompanhamento = styled.button`
  position: fixed;
  right: 130px;
  bottom: 50px;
  z-index: 2;
  border-radius: 100%;
  border: 0;
  outline: none;
  padding: 12px 14px;
  background-color: #ccc;
  color: #fff;
  cursor: pointer;

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px 0 rgba(0,0,0,0.5);
  }
`;

export const BotaoFrequentes = styled.button`
  position: fixed;
  right: 50px;
  bottom: 120px;
  z-index: 2;
  border-radius: 100%;
  border: 0;
  outline: none;
  padding: 13px 15px;
  background-color: #ff7777;
  color: #fff;
  cursor: pointer;

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px 0 rgba(0,0,0,0.5);
  }
`;

export const AbaContainer = styled.div`
  background: linear-gradient(to bottom, transparent, rgba(221,221,221,0.4));
  position: fixed;
  display: flex;
  right: 0;
  left: 0;

  > div {
    display: flex;
    flex-direction: row;
    flex: 1;
    max-width: 750px;
    justify-content: center;
  }
`;

export const AbaContainerAcompanhamento = styled.div`
  background: linear-gradient(to bottom, transparent, rgba(221,221,221,0.4));
  display: flex;
  right: 0;
  left: 0;

  @media screen and (min-width: 600px) {
    position: fixed;
  }

  > div {
    display: flex;
    flex-direction: row;
    flex: 1;
    max-width: 910px;
    justify-content: center;
  }

  @media screen and (max-width: 600px) {
    > div {
      flex-direction: column;
      grid-gap: 10px;
    }
  }
`;

export const AbaContainerTotem = styled.div`
  background: linear-gradient(to bottom, transparent, rgba(221,221,221,0.4));
  position: fixed;
  display: flex;
  top: 120px;
  right: 0;
  left: 0;

  > div {
    display: flex;
    flex-direction: row;
    flex: 1;
    max-width: 750px;
    justify-content: center;
  }
`;

export const BotaoAbaTotem = styled.button`
  background-color: ${({ ativo }) => (ativo ? '#fff' : '#828282')};
  border-top: 1px solid transparent;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 0px solid transparent;
  border-color: ${({ ativo }) => (ativo ? '#ddd' : 'transparent')};
  border-radius: 7px 7px 0 0;
  opacity: ${({ ativo }) => (ativo ? 1 : 0.4)};
  padding: ${espacamento.pequeno}px;
  margin: 0 ${espacamento.pequeno}px;
  display: flex;
  justify-content: center;
  flex: 1;
  color: ${({ ativo }) => (ativo ? '#888' : '#fff')};
  outline: none;
  font-size: 1.3em;
  font-weight: bold;
  cursor: pointer;

  :hover {
    background-color: ${({ ativo }) => (ativo ? '#fff' : '#888')};
    opacity: 1;
  }
`;

export const BotaoAba = styled.button`
  background-color: ${({ ativo }) => (ativo ? '#fff' : '#4d4d4d')};
  border-top: 1px solid transparent;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 0px solid transparent;
  border-color: ${({ ativo }) => (ativo ? '#ddd' : 'transparent')};
  border-radius: 7px 7px 0 0;
  opacity: ${({ ativo }) => (ativo ? 1 : 0.4)};
  padding: ${espacamento.pequeno}px;
  margin: 0 ${espacamento.pequeno}px;
  display: flex;
  justify-content: center;
  flex: 1;
  color: ${({ ativo }) => (ativo ? '#888' : '#fff')};
  outline: none;
  font-size: 0.92em;
  font-weight: bold;
  cursor: pointer;

  :hover {
    background-color: ${({ ativo }) => (ativo ? '#fff' : '#888')};
    opacity: 1;
  }
`;

export const BotaoLocalizacao = styled.button`
  border-radius: 4px;
  padding: ${espacamento.ultraPequeno}px ${espacamento.extraPequeno}px;
  align-items: center;
  cursor: pointer;
  border: none;
  outline: none;
  color: #fff;
  background-color: #2a7ae2;
  position: absolute;
  right: 5px;
  top: 5px;

  :hover {
    background-color: #2aaae2;
  }
`;

export const LinkNude = styled(Link)`
  text-decoration: none;
  display: flex;

  :hover {
    text-decoration: none;
  }

  button {
    flex: 1;
  }
`;

export const BotaoUpTotemModal = styled.button`
  position: fixed;
  right: 45px;
  top: 95px;
  z-index: 2;
  border-radius: 10px;
  border: 0;
  outline: none;
  padding: 12px 12px;
  background-color: #d9d9d9;
  color: #fff;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

  svg {
    fill: #646464;
    :active {
      fill: #858585;
    }
  }
`;

export const BotaoDownTotemModal = styled.button`
  position: fixed;
  right: 45px;
  bottom: 55px;
  z-index: 2;
  border-radius: 10px;
  border: 0;
  outline: none;
  padding: 12px 12px;
  background-color: #d9d9d9;
  color: #fff;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

  svg {
    fill: #646464;
    :active {
      fill: #858585;
    }
  }
`;

export const BotaoStatusAcompanhamento = styled.button`
  font-family: "Segoe UI";
  font-size: 16px;
  padding: 18px 15px;
  background-color: ${({ ativo }) => (ativo ? '#F9F9F9' : '#fff')};
  border: 0;
  box-shadow: inset 0px ${({ ativo }) => (ativo ? '-8px' : '-5px')} ${({ corFundo }) => corFundo || '#999'};
  cursor: pointer;
  flex: 0 1 180px;
  
  :hover {
    box-shadow: inset 0px -8px ${({ corFundo }) => corFundo || '#999'};
  }

  @media screen and (max-width: 800px) {
    font-size: 14px;
  }
`;
